import { render, staticRenderFns } from "./group-control-slot.vue?vue&type=template&id=1c83084c&scoped=true"
import script from "./group-control-slot.vue?vue&type=script&lang=js"
export * from "./group-control-slot.vue?vue&type=script&lang=js"
import style0 from "./group-control-slot.vue?vue&type=style&index=0&id=1c83084c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c83084c",
  null
  
)

export default component.exports